import { render, staticRenderFns } from "./CompCarouselPeopleCycle.vue?vue&type=template&id=2d6204fb&scoped=true"
import script from "./CompCarouselPeopleCycle.vue?vue&type=script&lang=js"
export * from "./CompCarouselPeopleCycle.vue?vue&type=script&lang=js"
import style0 from "./CompCarouselPeopleCycle.vue?vue&type=style&index=0&id=2d6204fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6204fb",
  null
  
)

export default component.exports